<div class="col-sm-12" *ngIf="!isEdit" id="pgmJourFerie" style="height: 100%; padding: 5px 0;">
  <div class="fiche col-sm-12" style="padding: 2px 20px 5px 20px;">
    <div class="text-right col-sm-12 pull-right" style="padding-right: 0;">
      <div class="col-sm-7 fiche-client" style="white-space: nowrap;">
        <div> Mouvements supplémentaires </div>
      </div>
      <button class="uppercase" id="savecont" (click)="save()"> Enregistrer </button>
    </div>
  </div>
  <div class="contente ligneBon col-sm-12" style="color: #000;padding: 15px; font-size: 13px;">
    <div class="addLigne col-sm-12 uppercase form-group">
      <div class="col-sm-7 text-left">
        <button class="btn-add" id="addLigne" (click)="showFormEdit({})">
          <i class="fa fa-plus"></i>
        </button>
        <span (click)="showFormEdit({})">Ajouter une ligne</span>
      </div>
      <label class="text-left uppercase text-underline historique col-sm-5"></label>
    </div>
    <div class="col-sm-12 ligneBon liste">

      <ngx-datatable style="height: 100%" class="material" [rows]="mouvementSupplementaire || []" [columnMode]="'force'"
        [headerHeight]="35" [footerHeight]="0" [rowHeight]="30" [selectionType]="'checkbox'"
        [messages]="{emptyMessage: 'Pas de lignes à afficher'}" [loadingIndicator]="loadingIndicator"
        [selected]="selected">

        <ngx-datatable-column prop="dateaffiche">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Date </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            {{value}}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column prop="operationAffiche">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Opération </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <span> {{value}} </span>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column prop="exutoire.libelleObjetEntite">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Exutoire</span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <span> {{value}} </span>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column [width]="80" [sortable]="false" [canAutoResize]="false" [draggable]="false"
          [resizeable]="false">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
            <div class="text-center">
              <button class="btn-detail" (click)="showFormEdit(row, true);">
                <i class="fa fa-pencil"></i>
              </button>
              <button class="btn-detail" (click)="delete(row)">
                <i class="fa fa-trash"></i>
              </button>
            </div>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
  </div>
</div>
<div class="col-sm-12" *ngIf="isEdit" id="pgmJourFerie" style="height: 100%; padding: 5px 0;">
  <div class="fiche col-sm-12" style="padding: 2px 20px 5px 20px;">
    <div class="text-right col-sm-12 pull-right" style="padding-right: 0;">
      <div class="col-sm-7 fiche-client" style="white-space: nowrap;">
        <div> {{selectedRow.add ? 'Ajouter' : 'Modifier'}} un mouv. supp. </div>
      </div>
      <button class="uppercase" id="savecont" (click)="saveMouv()"> Enregistrer </button>
    </div>
  </div>
  <div class="contente ligneBon  col-sm-10 col-sm-offset-1" style="color: #000;padding: 15px; font-size: 13px;">
    <div class="form-group col-sm-12" style="padding: 0">
      <span class="col-sm-12" style="padding: 0"> Date :
      </span>
      <div class="col-sm-12 form-group" style="padding: 0">
        <input type="text" class="col-sm-12 date" id="date1" [ngModel]="selectedRow.dateStart"
          (ngModelChange)="selectedRow.dateStart = $event; changeDateStart($event);" placeholder="Date debut"
          ngbDatepicker NgbInputDatepicker [autoClose]="false" #d="ngbDatepicker" (focus)="d.open();"
          (dateSelect)="selectDate($event, '#date1')" (keydown)="setFocuscalendar($event)"
          (keydown.enter)="d.close();common.changeDate($event, selectedRow.dateStart, '#h1');" autocomplete="off">
      </div>
    </div>
    <div class="form-group col-sm-12" style="padding: 0;">
      <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
        [(ngModel)]="selectedRow.auPlusTard">
      <span (click)="selectedRow.auPlusTard = !selectedRow.auPlusTard; " style="cursor: pointer;">
        Au plus tard </span>
    </div>
    <div class="form-group col-sm-12" style="padding: 0;">
      <span class="col-sm-12" style="padding: 0"> Heure : </span>
      <div class="col-sm-12" style="padding: 0">
        <input type="text" class="col-sm-12 inputtime" id="h1" placeholder="HH" [(ngModel)]="selectedRow.heure"
          [onReturn] autocomplete="off">
      </div>
    </div>
    <div class="form-group col-sm-12" style="padding: 0;">
      <span class="col-sm-12" style="padding: 0"> Durée(H) : </span>
      <div class="col-sm-12" style="padding: 0">
        <input type="text" class="col-sm-6 inputtime inputLeft50"  id="h2" placeholder="HH" [(ngModel)]="selectedRow.hourDuree"
          [onReturn] autocomplete="off">

        <input type="text" class="inputtime col-sm-6 inputRight50" placeholder="MM"
          [(ngModel)]="selectedRow.minDuree" autocomplete="off">
      </div>
    </div>
    <div class="form-group col-sm-12" style="padding: 0px;">
      <ng-template [ngIf]="defaultSelectedOPeration && defaultSelectedOPeration.id === 0">
        <app-autocomplete (selectfunction)="selectedRow.typeOperation = $event;" [results]="dataDepot"
          [highlight]="true" [isCombo]="true" [label]="'Type de l\'opération'" id="typeOperation"
          [placeholder]="'Type de l\'opération'" [defaultselected]="selectedRow.typeOperation"
          [defaultsearch]="selectedRow.typeOperation ? selectedRow.typeOperation.libelleObjetEntite : ''">
        </app-autocomplete>
      </ng-template>
      <ng-template [ngIf]="defaultSelectedOPeration && defaultSelectedOPeration.id === 1">
        <app-autocomplete (selectfunction)="selectedRow.typeOperation = $event;" [results]="dataRetrait"
          [highlight]="true" [isCombo]="true" [label]="'Type de l\'opération'" id="typeOperation"
          [placeholder]="'Type de l\'opération'" [defaultselected]="selectedRow.typeOperation"
          [defaultsearch]="selectedRow.typeOperation ? selectedRow.typeOperation.libelleObjetEntite : ''">
        </app-autocomplete>
      </ng-template>
      <ng-template [ngIf]="defaultSelectedOPeration && defaultSelectedOPeration.id === 2">
        <app-autocomplete (selectfunction)="selectedRow.typeOperation = $event;" [results]="dataRotation"
          [highlight]="true" [isCombo]="true" [label]="'Type de l\'opération'" id="typeOperation"
          [placeholder]="'Type de l\'opération'" [defaultselected]="selectedRow.typeOperation"
          [defaultsearch]="selectedRow.typeOperation ? selectedRow.typeOperation.libelleObjetEntite : ''">
        </app-autocomplete>
      </ng-template>
      <ng-template
        [ngIf]="defaultSelectedOPeration && defaultSelectedOPeration.id === 6 && !societe.operationBenneSupp">
        <app-autocomplete (selectfunction)="selectedRow.typeOperation = $event;" [results]="dataAutre"
          [highlight]="true" [isCombo]="true" [label]="'Type de l\'opération'" id="typeOperation"
          [placeholder]="'Type de l\'opération'" [defaultselected]="selectedRow.typeOperation"
          [defaultsearch]="selectedRow.typeOperation ? selectedRow.typeOperation.libelleObjetEntite : ''">
        </app-autocomplete>
      </ng-template>
      <ng-template [ngIf]="societe.operationBenneSupp  && defaultSelectedOPeration && defaultSelectedOPeration.id !== 0 && defaultSelectedOPeration.id !== 1
                                        && defaultSelectedOPeration.id !== 2 ">
        <ng-template [ngIf]="isBenneEnPlace(defaultSelectedOPeration) ">
          <app-autocomplete (selectfunction)="selectedRow.typeOperation = $event;" [results]="dataOppSuppBennePlace"
            [highlight]="true" [isCombo]="true" [label]="'Type de l\'opération'" id="typeOperation"
            [placeholder]="'Type de l\'opération'" [defaultselected]="selectedRow.typeOperation"
            [defaultsearch]="selectedRow.typeOperation ? selectedRow.typeOperation.libelleObjetEntite : ''">
          </app-autocomplete>
        </ng-template>
        <ng-template [ngIf]="isBenneNonEnPlace(defaultSelectedOPeration)">
          <app-autocomplete (selectfunction)="selectedRow.typeOperation = $event;" [results]="dataOppSupp"
            [highlight]="true" [isCombo]="true" [label]="'Type de l\'opération'" id="typeOperation"
            [placeholder]="'Type de l\'opération'" [defaultselected]="selectedRow.typeOperation"
            [defaultsearch]="selectedRow.typeOperation ? selectedRow.typeOperation.libelleObjetEntite : ''">
          </app-autocomplete>
        </ng-template>
      </ng-template>
      <ng-template [ngIf]="!societe.operationBenneSupp  && defaultSelectedOPeration && defaultSelectedOPeration.id !== 0 && defaultSelectedOPeration.id !== 1
                                        && defaultSelectedOPeration.id !== 2 && defaultSelectedOPeration.id !== 6">
        <ng-template [ngIf]="isBenneEnPlace(defaultSelectedOPeration) ">
          <app-autocomplete (selectfunction)="selectedRow.typeOperation = $event;" [results]="dataOppSuppBennePlace"
            [highlight]="true" [isCombo]="true" [label]="'Type de l\'opération'" id="typeOperation"
            [placeholder]="'Type de l\'opération'" [defaultselected]="selectedRow.typeOperation"
            [defaultsearch]="selectedRow.typeOperation ? selectedRow.typeOperation.libelleObjetEntite : ''">
          </app-autocomplete>
        </ng-template>
        <ng-template [ngIf]="isBenneNonEnPlace(defaultSelectedOPeration)">
          <app-autocomplete (selectfunction)="selectedRow.typeOperation = $event;" [results]="dataOppSupp"
            [highlight]="true" [isCombo]="true" [label]="'Type de l\'opération'" id="typeOperation"
            [placeholder]="'Type de l\'opération'" [defaultselected]="selectedRow.typeOperation"
            [defaultsearch]="selectedRow.typeOperation ? selectedRow.typeOperation.libelleObjetEntite : ''">
          </app-autocomplete>
        </ng-template>
      </ng-template>
    </div>
    <div class="form-group col-sm-12" style="padding: 0px;"
      *ngIf="societe.operationBenneSupp && societe.operationBenneParDefaut && dataisOpSurBenneEnPlace && dataisOpSurBenneEnPlace.length &&
                        selectedRow.typeOperation && (selectedRow.typeOperation.id !== 0 && selectedRow.typeOperation.id !== 1)">
      <app-autocomplete (focusfunction)="objectFocus.champOperationDefaut = true;"
        (selectfunction)="setValue($event, 'champOperationDefaut'); defaultSelectedDefaut = $event;"
        [results]="dataisOpSurBenneEnPlace" [highlight]="true" [isCombo]="true" [label]="'Op. par defaut'"
        id="champOperationDefaut" [placeholder]="'Op. par defaut'" [defaultselected]="defaultSelectedDefaut"
        [defaultsearch]="defaultSelectedDefaut ? defaultSelectedDefaut.libelleObjetEntite : ''">
      </app-autocomplete>
    </div>
    <div class="col-sm-12 form-group" style="padding: 0;">
      <app-autocomplete [placeholder]="'Exutoire'" (searchfunction)="searchExutoire($event)"
        (selectfunction)="selectedRow.exutoire = $event" [id]="'exutoire'" [results]="listExutoire" [label]="'Exutoire'"
        [defaultselected]="selectedRow.exutoire"
        [defaultsearch]="selectedRow.exutoire ? selectedRow.exutoire.libelleObjetEntite : ''">
      </app-autocomplete>
    </div>
    <div class="form-group col-sm-12" style="padding: 0;" *ngIf="isShowSite">
      <app-autocomplete [label]="'Site'" [placeholder]="'site'" (searchfunction)="searchSite($event)"
        (selectfunction)="selectedRow.sitePrest = $event" [results]="listeSiteCA" [highlight]="true"
        [dropdownclass]="mindropdown" [selectvalue]="true" [isCombo]="true" [id]="'sitePrest'"
        [defaultselected]="selectedRow.sitePrest"
        [defaultsearch]="selectedRow.sitePrest ? selectedRow.sitePrest.nom : ''">
      </app-autocomplete>
    </div>
    <div class="form-group col-sm-12" style="padding: 0; margin-bottom: 15px;">
      <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
        [(ngModel)]="selectedRow.isImportant ">
      <span (click)="selectedRow.isImportant = !selectedRow.isImportant" style="cursor: pointer;">
        Prestation importante </span>
    </div>
    <div class="form-group">
      <span> Infos prestation :
      </span>
      <input type="text" class="form-control inputtime info" id="infomvt" [(ngModel)]="selectedRow.infoNextMouv"
        (keyup.enter)="common.focusElement('#infosup')" (focus)="selectedRow.infomvtfocus = true;"
        (blur)="selectedRow.infomvtfocus = false;" autocomplete="off">
    </div>
  </div>
</div>


<ng-template #msg>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <strong class="cofirmemsg"> {{ error }} </strong>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal()"> Fermer </button>
    </div>
  </div>
</ng-template>